import { multipart_headers } from '../state/helpers';
export const generalService = {
    updateGeneralData: (data) => window.axios.post('store-general-data', data,{ headers: multipart_headers() }),
};